import Com1 from "./components/Com1";
import Com3 from "./components/Com3";
import Com4 from "./components/Com4";
import Com5 from "./components/Com5";
import DesignCom from "./components/DesignCom";

import { axiosInstance } from "api";
import NoticeModal from "components/Modal/NoticeModal";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
import { useRef } from "react";
import { useCookies } from "react-cookie";
import { useQuery } from "react-query";
import { Wrapper } from "./style";
const Home = () => {
  const [cookies] = useCookies();
  const CheckCookieById = (id) => {
    return cookies["sketch_htm" + id];
  };
  // notice modal query
  const { data: notice, isSuccess } = useQuery("notices", () => axiosInstance.get("/notices"));

  const ref = useRef();
  useScrollFadeIn(ref);
  return (
    <Wrapper ref={ref} className="fade-in">
      {isSuccess && notice?.map((v) => !CheckCookieById(v.id) && <NoticeModal data={v} key={v.id} />)}
      <Com1></Com1>
      {/* <Com2></Com2> */}
      <Com3></Com3>
      <Com4></Com4>
      <Com5></Com5>
      <DesignCom></DesignCom>
    </Wrapper>
  );
};

export default Home;
